import { PageContentWrapper } from 'app/member/layouts/wrapper/page-content';
import React from 'react';
import { Routes, Route } from 'react-router-dom';

import ListCampaign from './list/list';
import { CampaignPage } from './views';

const CampaignModule = () => {
  return (
    <PageContentWrapper>
      <Routes>
        <Route path="/:id" element={<CampaignPage />} />
        <Route path="/" element={<ListCampaign />} />
      </Routes>
    </PageContentWrapper>
  );
};

export default CampaignModule;
